<template>
  <div class="lh-homes imgs" style="background-image:url(img/d1.png)">
  	<div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：{{logoText}}</span></div>
  	<ul class="lh-progress1-item">
  		<li v-for="(item,idx) in datas" :class="[item.hover,item.end]" :data-idx="idx" @click="item.hover?openLayer($event):''">
  			<div class="jt"><img src="img/jt1.png" /></div>
  			<div class="icon"><img src="img/d7.png" /></div>
  		</li>
  	</ul>
  	<div class="lh-progress1-layer imgs" style="background-image:url(img/d2.png)" :class="datas[datasIdx].class">
  		<div class="result"><img :src="resultIcon" /></div>
  		<div class="ccont" v-html="datas[datasIdx].ccont"></div>
  		<ul class="lh-layer-item clearfix">
  			<li v-for="(item,idx) in datas[datasIdx].result" :class="item.hover" :data-idx="idx" :data-answer="item.answer" @click="answer($event)">{{item.title}}</li>
  		</ul>
  		<div class="next" @click="next($event)"><img src="img/d6.png" /></div>
  	</div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:4,type:'culture'},
			logoText:'工伤——工伤处理流程',
			resultIcon:'img/d3.png',
			datasIdx:0,
			datas:[
				{ccont:'所在单位应当自事故伤害发生之日或者被诊断、鉴定为职业病之日起（    ）内，向统筹地区社会保险行政部门提出工伤认定申请。遇有特殊情况，经报社会保险行政部门同意，申请时限可以适当延长。',class:"",hover:'on',end:'',result:[
					{title:'A.一周',answer:false,hover:''},
					{title:'B.30天',answer:true,hover:''},
					{title:'C.180天',answer:false,hover:''},
					{title:'D.一年',answer:false,hover:''}
				]},
				{ccont:'用人单位未按前款规定提出工伤认定申请的，工伤职工或者其近亲属、工会组织在事故伤害发生之日或者被诊断、鉴定为职业病之日起（    ）内，可以直接向用人单位所在地统筹地区社会保险行政部门提出工伤认定申请。',class:"",hover:'',end:'',result:[
					{title:'A.一周',answer:false,hover:''},
					{title:'B.30天',answer:false,hover:''},
					{title:'C.180天',answer:false,hover:''},
					{title:'D.一年',answer:true,hover:''}
				]},
				{ccont:'工伤认定申请应当提交下列何种材料？（    ）',class:"one",hover:'',end:'',result:[
					{title:'A.工伤认定申请表',answer:false,hover:''},
					{title:'B.与用人单位存在劳动关系（包括事实劳动关系）的证明材料',answer:false,hover:''},
					{title:'C.医疗诊断证明或者职业病诊断证明书（或者职业病诊断鉴定书）',answer:false,hover:''},
					{title:'D.以上全部 ',answer:true,hover:''}
				]},
				{ccont:'社会保险行政部门受理工伤认定申请后，根据审核需要可以对事故伤害进行调查核实，用人单位、职工、工会组织、医疗机构以及有关部门应当予以协助。职业病诊断和诊断争议的鉴定，依照职业病防治法的有关规定执行。对依法取得职业病诊断证明书或者职业病诊断鉴定书的，社会保险行政部门（    ）再次进行调查核实。',hover:'',end:'',result:[
					{title:'A.需要',answer:false,hover:''},
					{title:'B.不需要',answer:false,hover:''},
					{title:'C.需要根据情况',answer:false,hover:''},
					{title:'D.需要根据当地政策',answer:true,hover:''}
				]},
				{ccont:'社会保险行政部门应当自受理工伤认定申请之日起（    ）内作出工伤认定的决定，并书面通知申请工伤认定的职工或者其近亲属和该职工所在单位。社会保险行政部门对受理的事实清楚、权利义务明确的工伤认定申请，应当在（    ）内作出工伤认定的决定。',hover:'',end:'',result:[
					{title:'A.15日、30日',answer:false,hover:''},
					{title:'B.30日、60日',answer:false,hover:''},
					{title:'C.60日、15日',answer:true,hover:''},
					{title:'D.六个月、一年',answer:false,hover:''}
				]},
				{ccont:'职工发生工伤，经治疗伤情相对稳定后（    ），应当进行劳动能力鉴定。',class:"one",hover:'',end:'',result:[
					{title:'A. 出院，需要赔偿误工费的',answer:false,hover:''},
					{title:'B.仍在治疗，需要后续赔偿的',answer:false,hover:''},
					{title:'C.存在残疾、影响劳动能力的',answer:true,hover:''},
					{title:'D.治疗期间所在公司恶意解除与其劳动合同的',answer:false,hover:''}
				]},
				{ccont:'设区的市级劳动能力鉴定委员会应当自收到劳动能力鉴定申请之日起（    ）内作出劳动能力鉴定结论，必要时，作出劳动能力鉴定结论的期限可以延长（    ）。劳动能力鉴定结论应当及时送达申请鉴定的单位和个人。',hover:'',end:'',result:[
					{title:'A.15日、30日',answer:false,hover:''},
					{title:'B.30日、60日',answer:true,hover:''},
					{title:'C.60日、15日',answer:false,hover:''},
					{title:'D.六个月、一年',answer:false,hover:''}
				]},
				{ccont:'下面正确的排列顺序是（    ）<br />1.单位于30日内，个人于一年内，向地区社会保险行政部门提出工伤认定申请。<br />2.职工发生事故伤害或者按照职业病防治法规定被诊断、鉴定为职业病。<br />3.提供工伤认定申请材料：（一）工伤认定申请表（二）与用人单位存在劳动关系（包括事实劳动关系的证明材料（三）医疗诊断证明或者职业病诊断证明书（或者职业病诊断鉴定书）。<br />4.职工发生工伤，经治疗伤情相对稳定后存在残疾、影响劳动能力的，应当进行劳动能力鉴定 。<br />5.社会保险行政部门应当自受理工伤认定申请之日起60日内作出工伤认定的决定，并书面通知申请工伤认定的职工或者其近亲属和该职工所在单位。社会保险行政部门对受理的事实清楚、权利义务明确的工伤认定申请，应当在15日内作出工伤认定的决定。 <br />6.待遇审批。<br />7.工伤保险待遇支付。<br />8.设区的市级劳动能力鉴定委员会应当自收到劳动能力鉴定申请之日起60日内作出劳动能力鉴定结论，必要时，作出劳动能力鉴定结论的期限可以延长30日。劳动能力鉴定结论应当及时送达申请鉴定的单位和个人。',class:"two",hover:'',end:'',result:[
					{title:'A.21354786',answer:true,hover:''},
					{title:'B.12345678',answer:false,hover:''},
					{title:'C.45612378',answer:false,hover:''},
					{title:'D.23784561',answer:false,hover:''}
				]}
			]
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
    },
	components:{
		Footer
	},
	methods:{
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		},
		openLayer(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx');
			that.datas[idx].hover="";
			$('.lh-homes').addClass('Layer');
		},
		next(e){
			var that=this;
			$('.lh-homes').removeClass('Layer');
			setTimeout(function(){
				that.resultIcon="img/d3.png";
				$('.lh-progress1-layer').removeClass('on');
				that.datasIdx+=1;
				that.datas.forEach(function(v,i){
					v.hover="";
				});
				if(that.datasIdx>=8){
					that.$router.replace({ path: 'treatment'}); return false;
				}
				that.datas[that.datasIdx].hover="on";
			},200);
		},
		answer(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx'),answer=$(e.currentTarget).data('answer');
			that.datas[that.datasIdx].result.forEach(function(v,i){
				v.hover="";
			});
			that.datas[that.datasIdx].result[idx].hover="on";
			if(that.datas[that.datasIdx].result[idx].answer){
				that.resultIcon="img/d5.png";
				$('.lh-progress1-layer').addClass('on');
			}else{
				that.resultIcon="img/d4.png";
				$('.lh-progress1-layer').removeClass('on');
			}
		}
	}
}
</script>
